/**
 * Вейвер в отчёте оператора обязателен (01.10.2026, владелец): «поле вейвера заполняется в любом
 * случае — если вейвера нет, оператор ставит галочку и пишет, почему; типичные причины, в том
 * числе своя». Общие правила для сервера (game-reports/waiver-gate.ts) и формы (op/waiverBlock).
 *
 * Обязателен только ОСНОВНОЙ отчёт (вейвер один на бронь, напарник его не ведёт) и только для
 * игр с даты запуска: пересдача старых отчётов (окно правок, возврат из ОО) не должна вдруг
 * требовать вейвер, которого тогда никто не просил.
 */

/** С этой даты игры (YYYY-MM-DD) основной отчёт без вейвера не принимается. */
export const WAIVER_REQUIRED_FROM = "2026-10-01";

/** Типичные причины — кнопками; своя — текстом. */
export const NO_WAIVER_REASONS: readonly string[] = ["Детская команда, взрослых не было", "Учебная игра — играли сотрудники"];

/** Длина причины в базе — с запасом на «причина. своя причина». */
export const NO_WAIVER_REASON_MAX = 300;

/** Нужен ли вейвер этому отчёту: основной и игра не раньше даты запуска. */
export function waiverRequired(gameDate: string | null | undefined, isPrimary: boolean): boolean {
  return isPrimary && typeof gameDate === "string" && gameDate.slice(0, 10) >= WAIVER_REQUIRED_FROM;
}

/** Причина одной строкой: выбранные кнопки, потом своя — «Детская команда…. Своя». */
export function noWaiverReason(picked: readonly string[], custom: string): string {
  return [...picked.map((s) => s.trim()).filter(Boolean), custom.trim()].filter(Boolean).join(". ").slice(0, NO_WAIVER_REASON_MAX);
}
